import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { isBrowser } from 'utils/domUtils';

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: (isBrowser() && window.innerWidth) || 0,
    height: (isBrowser() && window.innerHeight) || 0
  });

  useEffect(() => {
    let active = true;
    const changeWindowSize = debounce(() => {
      if (!active) return;
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }, 100);

    changeWindowSize();
    window.addEventListener('resize', changeWindowSize);

    return () => {
      active = false;
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize;
};
